import React from 'react';

const DotsIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...rest}>
      <path d="M11.6969 15.9998C11.6969 16.9387 10.9358 17.6998 9.99688 17.6998C9.05799 17.6998 8.29688 16.9387 8.29688 15.9998C8.29688 15.0609 9.05799 14.2998 9.99688 14.2998C10.9358 14.2998 11.6969 15.0609 11.6969 15.9998Z" fill="#909195"/>
      <path d="M11.6969 9.9998C11.6969 10.9387 10.9358 11.6998 9.99688 11.6998C9.05799 11.6998 8.29688 10.9387 8.29688 9.9998C8.29688 9.06092 9.05799 8.2998 9.99688 8.2998C10.9358 8.2998 11.6969 9.06092 11.6969 9.9998Z" fill="#909195"/>
      <path d="M11.6969 3.9998C11.6969 4.93869 10.9358 5.6998 9.99688 5.6998C9.05799 5.6998 8.29688 4.93869 8.29688 3.9998C8.29688 3.06092 9.05799 2.2998 9.99688 2.2998C10.9358 2.2998 11.6969 3.06092 11.6969 3.9998Z" fill="#909195"/>
    </svg>
  );
};

export default DotsIcon;